import React, { useState } from "react";
import { setFeedHandle } from "../../api";

const HANDLE_RE = /^[a-z0-9_]{3,20}$/;

/**
 * HandleSetupCard — the one-time feed-identity step, in majlis style.
 *
 * Shown on /majlis/submit when eligibility.reason === "no_handle". The
 * @handle is permanent (server-enforced set-once); the display name can be
 * changed later. The handle itself is Latin (a-z, 0-9, _) so its input is a
 * dir="ltr" island inside the RTL page.
 *
 * Props: onDone — () => void, re-fetch eligibility after a successful save.
 */
export default function HandleSetupCard({ onDone }) {
  const [handle, setHandle] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const save = async () => {
    const cleaned = handle.trim().toLowerCase();
    if (!HANDLE_RE.test(cleaned)) {
      setError("المعرّف: ٣–٢٠ حرفًا لاتينيًّا صغيرًا أو أرقامًا أو «_».");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await setFeedHandle(cleaned, displayName.trim());
      onDone && onDone();
    } catch (e) {
      setError(
        e.status === 409 ? "هذا المعرّف محجوز — جرّب غيرَه." : "تعذّر الحفظ — حاول مرة أخرى."
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="rounded-[14px] p-5 font-plex"
      style={{ background: "var(--mj-surface)", border: "1px solid var(--mj-line)" }}
    >
      <p className="text-[15px] font-bold" style={{ color: "var(--mj-cream)" }}>
        اخترْ اسمَك في المجلس
      </p>
      <p className="text-[12.5px] mt-1 mb-4" style={{ color: "var(--mj-muted)" }}>
        يظهرُ على كلِّ ما تنشرُه. المعرِّفُ <b dir="ltr">@handle</b> دائمٌ لا يتغيّر،
        وأمّا الاسمُ الظاهرُ فيمكنُ تغييرُه لاحقًا.
      </p>
      <div className="flex flex-col gap-2.5">
        <input
          dir="ltr"
          className="rounded-xl px-4 py-2.5 text-[15px] outline-none"
          style={{
            background: "var(--mj-raised)",
            border: "1px solid var(--mj-line)",
            color: "var(--mj-cream)",
          }}
          placeholder="abu_maryam :المعرّف، مثل"
          value={handle}
          onChange={(e) => setHandle(e.target.value)}
          maxLength={20}
          autoCapitalize="none"
          autoCorrect="off"
        />
        <input
          dir="auto"
          className="rounded-xl px-4 py-2.5 font-arabic text-[17px] outline-none"
          style={{
            background: "var(--mj-raised)",
            border: "1px solid var(--mj-line)",
            color: "var(--mj-cream)",
          }}
          placeholder="الاسمُ الظاهرُ — مثل: أبو مريم"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          maxLength={40}
        />
      </div>
      {error && (
        <p className="text-[12px] mt-2 px-1" style={{ color: "var(--mj-flag)" }}>{error}</p>
      )}
      <button
        onClick={save}
        disabled={busy || !handle.trim()}
        className="w-full rounded-full px-4 py-2.5 text-[14px] font-bold mt-4 disabled:opacity-40"
        style={{ background: "var(--mj-gold)", color: "var(--mj-bg)" }}
      >
        {busy ? "جارٍ الحفظ…" : "احفظْ وابدأِ النشر"}
      </button>
    </div>
  );
}
